export const DATE_FORMAT = "DD-MMM-YYYY";
export const DATE_TIME_FORMAT = "DD-MMM-YYYY h:mm a";
export const DATE_FORMAT_NUMERICAL = "DD/MM/YYYY";
export const APOLLO_DATE_FORMAT = "YYYY-MM-DD";
export const CASE_TYPES = [
  {
    id: "credential-verification",
    name: "Credential Verification",
  },
  {
    id: "send-report",
    name: "Send Report",
  },
];

// check if the current environment is storybook
export const IsInStorybookEnv = () => {
  console.log(window.location.hostname);
  return (window.location.hostname === "localhost" && window.location.port === "6006") || window.location.hostname.includes("chromatic.com");
};

export const FormatTimeCounter = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};

export const GENDERS = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
  { label: "X", value: "X" },
];

export const FileUploadSpec = {
  Passport: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ["image/jpeg", "image/png"],
    permittedExtensions: ["jpg", "jpeg", "png"],
    fileName: "passport.jpg",
    fieldName: "passport",
  },
  PassportExpirationPage: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ['image/jpeg', 'image/png', 'application/pdf'],
    permittedExtensions: ['jpg', 'jpeg', 'png', 'pdf'],
    fileName: "passport-expiration-page",
    fieldName: "passportExpiration",
  },
  PassportTranslation: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ["application/pdf"],
    permittedExtensions: ["pdf"],
    fileName: "passport-translation.pdf",
    fieldName: "passportTranslation",
  },
  Photo: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ["image/jpeg", "image/png"],
    permittedExtensions: ["jpg", "jpeg", "png"],
    fileName: "photo.jpg",
    fieldName: "photo",
  },
  NotarizedIdForm: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ["application/pdf"],
    permittedExtensions: ["pdf"],
    fileName: "id-form-notarized.pdf",
    fieldName: "notarizedIdForm",
  }
};

export const PhoneTypes = [
  {
    label: "Home",
    value: "home",
  },
  {
    label: "Work",
    value: "work",
  },
  {
    label: "Cell",
    value: "cell",
  },
  {
    label: "Other",
    value: "other",
  },
];
